
import React, { useEffect, useRef, useState } from 'react';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { Link } from 'react-router-dom';

function Header() {
  const [isAboutDropdownOpen, setIsAboutDropdownOpen] = useState(false);
  const [isResourcesDropdownOpen, setIsResourcesDropdownOpen] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isMobileAboutOpen, setIsMobileAboutOpen] = useState(false);
  const [isMobileResourcesOpen, setIsMobileResourcesOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const toggleRef = useRef(null);
  const sidebarRef = useRef(null);
  const aboutDropdownRef = useRef(null);
  const resourcesDropdownRef = useRef(null);

  const resources = [
    { name: 'Library', link: '/library', icon: 'fa-book' },
    { name: 'Events', link: '/eventslist', icon: 'fa-calendar' },
    { name: 'Ask our Ulema', link: '/contactus', icon: 'fa-envelope' },
  ];

  const aboutItems = [
    { name: 'Our History', link: '/aboutus', icon: 'fa-history' },
    { name: 'Office Bearers', link: '/officebearers', icon: 'fa-user-tie' },
    { name: 'District Committee', link: '/commitee', icon: 'fa-users-cog' },
    { name: 'Brochures', link: '/brochures', icon: 'fa-book-open' },
  ];

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        isSidebarOpen &&
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target) &&
        !toggleRef.current.contains(event.target)
      ) {
        setIsSidebarOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isSidebarOpen]);

  return (
    <div>
      {/* Mobile Logo */}
      <div className='fixed z-40 top-3 sm:top-4 md:top-5 left-3 sm:left-4 md:left-8 xl:hidden'>
        <Link to='/'>
          <img
            className='w-16 sm:w-20 md:w-24 hover:scale-105 transition-transform duration-300'
            src='images/favicon.ico'
            alt="Logo"
          />
        </Link>
      </div>

      {/* Mobile Header */}
      <header className='xl:hidden'>
        <nav className='flex items-center justify-between'>
          <div className='fixed top-3 sm:top-4 md:top-5 right-3 sm:right-4 md:right-8 z-40'>
            <button
              ref={toggleRef}
              onClick={toggleSidebar}
              className="p-3 sm:p-3.5 md:p-4 relative bg-gray-800/90 backdrop-blur-sm rounded-lg hover:bg-gray-700 transition-colors duration-300"
            >
              <i className={`fa ${isSidebarOpen ? 'fa-times' : 'fa-bars'} text-white text-2xl sm:text-3xl md:text-3xl transition-transform duration-300`}></i>
            </button>
          </div>

          {/* Overlay */}
          {isSidebarOpen && (
            <div
              className="fixed inset-0 bg-black/50 backdrop-blur-sm z-40"
              onClick={() => setIsSidebarOpen(false)}
            ></div>
          )}

          {/* Sidebar */}
          <div
            ref={sidebarRef}
            className={`fixed top-0 right-0 h-full w-72 sm:w-80 md:w-96 bg-white z-50 transform transition-transform duration-300 ease-in-out overflow-y-auto shadow-2xl ${isSidebarOpen ? 'translate-x-0' : 'translate-x-full'}`}
          >
            <div className="p-6 sm:p-8 md:p-10">
              <div className="flex justify-between items-center mb-8">
                <h2 className="text-xl sm:text-2xl font-bold text-gray-800">Menu</h2>
                <button
                  onClick={() => setIsSidebarOpen(false)}
                  className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
                >
                  <i className="fa fa-times text-gray-600 text-xl"></i>
                </button>
              </div>

              <ul className="space-y-1">
                {/* About Us */}
                <li className="border-b border-gray-100">
                  <button
                    className="w-full flex justify-between items-center py-4 text-base sm:text-lg font-medium text-gray-800 hover:text-gray-600 transition-colors"
                    onClick={() => setIsMobileAboutOpen(!isMobileAboutOpen)}
                  >
                    <span>About Us</span>
                    <i className={`fa ${isMobileAboutOpen ? 'fa-chevron-up' : 'fa-chevron-down'} text-sm transition-transform duration-300`}></i>
                  </button>
                  <div className={`overflow-hidden transition-all duration-300 ${isMobileAboutOpen ? 'max-h-96 mb-4' : 'max-h-0'}`}>
                    <ul className="pl-4 space-y-2">
                      {aboutItems.map((item, index) => (
                        <li key={index}>
                          <Link
                            to={item.link}
                            className="block py-2 text-sm sm:text-base text-gray-600 hover:text-gray-800 hover:pl-2 transition-all duration-200"
                            onClick={() => setIsSidebarOpen(false)}
                          >
                            <i className={`fa ${item.icon} mr-2 text-xs`}></i>
                            {item.name}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                </li>

                <li className="border-b border-gray-100">
                  <Link to='/masajids' className="block py-4 text-base sm:text-lg font-medium text-gray-800 hover:text-gray-600 transition-colors" onClick={() => setIsSidebarOpen(false)}>
                    Our Masajids
                  </Link>
                </li>

                <li className="border-b border-gray-100">
                  <Link to='/ourcause' className="block py-4 text-base sm:text-lg font-medium text-gray-800 hover:text-gray-600 transition-colors" onClick={() => setIsSidebarOpen(false)}>
                    Causes
                  </Link>
                </li>

                {/* Resources */}
                <li className="border-b border-gray-100">
                  <button
                    className="w-full flex justify-between items-center py-4 text-base sm:text-lg font-medium text-gray-800 hover:text-gray-600 transition-colors"
                    onClick={() => setIsMobileResourcesOpen(!isMobileResourcesOpen)}
                  >
                    <span>Resources</span>
                    <i className={`fa ${isMobileResourcesOpen ? 'fa-chevron-up' : 'fa-chevron-down'} text-sm transition-transform duration-300`}></i>
                  </button>
                  <div className={`overflow-hidden transition-all duration-300 ${isMobileResourcesOpen ? 'max-h-96 mb-4' : 'max-h-0'}`}>
                    <ul className="pl-4 space-y-2">
                      {resources.map((resource, index) => (
                        <li key={index}>
                          <Link
                            to={resource.link}
                            className="block py-2 text-sm sm:text-base text-gray-600 hover:text-gray-800 hover:pl-2 transition-all duration-200"
                            onClick={() => setIsSidebarOpen(false)}
                          >
                            <i className={`fa ${resource.icon} mr-2 text-xs`}></i>
                            {resource.name}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                </li>

                <li className="pt-4">
                  <Link
                    to='/donate'
                    className="block w-full text-center py-3 sm:py-4 text-base sm:text-lg font-medium text-white bg-gray-800 hover:bg-gray-700 rounded-lg transition-colors shadow-md"
                    onClick={() => setIsSidebarOpen(false)}
                  >
                    Make Donation
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </header>

      {/* Desktop Header */}
     {/* Desktop Header */}
<div className={`hidden xl:block fixed top-0 left-0 right-0 z-30 transition-all duration-300 ${scrolled ? 'bg-white/95 backdrop-blur-md shadow-md py-3' : 'bg-transparent py-4 2xl:py-5'}`}>
  <div className="px-6 xl:px-10 2xl:px-16">
    <div className="flex items-center justify-between">

      {/* Logo — Left */}
      <div className="flex-shrink-0">
        <Link to='/'>
          <img
            className={`transition-all duration-300 hover:scale-105 ${scrolled ? 'w-20 2xl:w-24' : 'w-24 2xl:w-28'}`}
            src='images/favicon.ico'
            alt="Logo"
          />
        </Link>
      </div>

      {/* Nav + Donate — Right */}
      <div className="flex items-center gap-1 2xl:gap-2">

        {/* About Us Dropdown */}
        <div
          ref={aboutDropdownRef}
          className="relative"
          onMouseEnter={() => setIsAboutDropdownOpen(true)}
          onMouseLeave={() => setIsAboutDropdownOpen(false)}
        >
          <button className={`px-4 2xl:px-5 py-2 2xl:py-2.5 font-medium text-sm 2xl:text-base text-center transition-all duration-200 rounded-lg relative group ${scrolled ? 'text-gray-800 hover:text-gray-600' : 'text-white text-center hover:text-gray-200'}`}>
            About Us
            <i className={`fa fa-angle-down ml-1 text-xs transition-transform duration-200 ${isAboutDropdownOpen ? 'rotate-180' : ''}`}></i>
            <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-current transition-all duration-300 group-hover:w-full"></span>
          </button>

          {isAboutDropdownOpen && (
           <div className="absolute top-full left-0 w-48 bg-white shadow-xl rounded-lg z-50 border border-gray-100 mt-1 overflow-hidden">
  <ul className="py-2">
    {aboutItems.map((item, index) => (
      <li key={index}>
        <Link
          to={item.link}
          className="flex items-center justify-center px-4 py-3 hover:bg-gray-800 transition-colors duration-150 group"
        >
          <span className="text-sm font-medium text-gray-700 group-hover:text-white text-center">
            {item.name}
          </span>
        </Link>
      </li>
    ))}
  </ul>
</div>
          )}
        </div>

        {/* Our Masajids */}
        <Link to='/masajids'>
          <button className={`px-4 2xl:px-5 py-2 2xl:py-2.5 font-medium text-sm 2xl:text-base transition-all duration-200 rounded-lg relative group ${scrolled ? 'text-gray-800 hover:text-gray-600' : 'text-white hover:text-gray-200'}`}>
            Our Masajids
            <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-current transition-all duration-300 group-hover:w-full"></span>
          </button>
        </Link>

        {/* Our Causes */}
        <Link to='/ourcause'>
          <button className={`px-4 2xl:px-5 py-2 2xl:py-2.5 font-medium text-sm 2xl:text-base transition-all duration-200 rounded-lg relative group ${scrolled ? 'text-gray-800 hover:text-gray-600' : 'text-white hover:text-gray-200'}`}>
            Our Causes
            <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-current transition-all duration-300 group-hover:w-full"></span>
          </button>
        </Link>

        {/* Resources Dropdown */}
        <div
          ref={resourcesDropdownRef}
          className="relative"
          onMouseEnter={() => setIsResourcesDropdownOpen(true)}
          onMouseLeave={() => setIsResourcesDropdownOpen(false)}
        >
          <button className={`px-4 2xl:px-5 py-2 2xl:py-2.5 font-medium text-sm 2xl:text-base transition-all duration-200 rounded-lg relative group ${scrolled ? 'text-gray-800 hover:text-gray-600' : 'text-white hover:text-gray-200'}`}>
            Resources
            <i className={`fa fa-angle-down ml-1 text-xs transition-transform duration-200 ${isResourcesDropdownOpen ? 'rotate-180' : ''}`}></i>
            <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-current transition-all duration-300 group-hover:w-full"></span>
          </button>

          {isResourcesDropdownOpen && (
            <div className="absolute top-full left-0 w-48 bg-white shadow-xl rounded-lg z-50 border border-gray-100 mt-1 overflow-hidden">
  <ul className="py-2">
    {resources.map((resource, index) => (
      <li key={index}>
        <Link
          to={resource.link}
          className="flex items-center justify-center px-4 py-3 hover:bg-gray-900 transition-colors duration-150 group"
        >
          <span className="text-sm font-medium text-gray-700 group-hover:text-white text-center">
            {resource.name}
          </span>
        </Link>
      </li>
    ))}
  </ul>
</div>
          )}
        </div>

        {/* Make Donation */}
        <Link to='/donate'>
          <button className="px-5 2xl:px-6 py-2 2xl:py-2.5 ml-2 text-white bg-gray-800 hover:bg-gray-700 font-medium text-sm 2xl:text-base transition-all duration-200 rounded-3xl shadow-md hover:shadow-lg hover:scale-105">
            Make Donation
          </button>
        </Link>

      </div>
    </div>
  </div>
</div>
    </div>
  );
}

export default Header;

// working 24/03/26

// import React, { useEffect, useRef, useState } from 'react';
// import '@fortawesome/fontawesome-free/css/all.min.css';
// import { Link } from 'react-router-dom';

// function Header() {
//   // header functionality
//   const [isAboutDropdownOpen, setIsAboutDropdownOpen] = useState(false);
//   const [isResourcesDropdownOpen, setIsResourcesDropdownOpen] = useState(false);
//   const [isSidebarOpen, setIsSidebarOpen] = useState(false);
//   const [isMobileAboutOpen, setIsMobileAboutOpen] = useState(false);
//   const [isMobileResourcesOpen, setIsMobileResourcesOpen] = useState(false);
//   const [scrolled, setScrolled] = useState(false);
//   const toggleRef = useRef(null);
//   const sidebarRef = useRef(null);
//   const aboutDropdownRef = useRef(null);
//   const resourcesDropdownRef = useRef(null);

//   const resources = [
//     { name: 'Library', link: '/library', icon: 'fa-book' },
//     { name: 'Events', link: '/eventslist', icon: 'fa-calendar' },
//     { name: 'Ask our Ulema', link: '/contactus', icon: 'fa-envelope' },
//   ];

//   const aboutItems = [
//     { name: 'Our History', link: '/aboutus', icon: 'fa-history' },
//     { name: 'Office Bearers', link: '/officebearers', icon: 'fa-user-tie' },
//     { name: 'District Committee', link: '/commitee', icon: 'fa-users-cog' },
//     { name: 'Brochures', link: '/brochures', icon: 'fa-book-open' }
//   ];

//   const toggleSidebar = () => {
//     setIsSidebarOpen(!isSidebarOpen);
//   };

//   // Handle scroll effect
//   useEffect(() => {
//     const handleScroll = () => {
//       setScrolled(window.scrollY > 20);
//     };
//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (
//         isSidebarOpen &&
//         sidebarRef.current &&
//         !sidebarRef.current.contains(event.target) &&
//         !toggleRef.current.contains(event.target)
//       ) {
//         setIsSidebarOpen(false);
//       }
//     };
//     document.addEventListener('mousedown', handleClickOutside);
//     return () => {
//       document.removeEventListener('mousedown', handleClickOutside);
//     };
//   }, [isSidebarOpen]);

//   return (
//     <div className=''>
//       {/* Mobile Logo */}
//       <div className='fixed z-40 top-3 sm:top-4 md:top-5 left-3 sm:left-4 md:left-8 xl:hidden'>
//         <Link to='/'>
//           <img 
//             className='w-16 sm:w-20 md:w-24 hover:scale-105 transition-transform duration-300' 
//             src='images/favicon.ico' 
//             alt="Logo" 
//           />
//         </Link>
//       </div>

//       {/* Mobile screen header */}
//       <header className='xl:hidden'>
//         <nav className='flex items-center justify-between'>
//           <div className='fixed top-3 sm:top-4 md:top-5 right-3 sm:right-4 md:right-8 z-40'>
//             <button 
//               ref={toggleRef} 
//               onClick={toggleSidebar} 
//               className="p-3 sm:p-3.5 md:p-4 relative bg-gray-800/90 backdrop-blur-sm rounded-lg hover:bg-gray-700 transition-colors duration-300"
//             >
//               <i className={`fa ${isSidebarOpen ? 'fa-times' : 'fa-bars'} text-white text-2xl sm:text-3xl md:text-3xl transition-transform duration-300`} aria-hidden="true"></i>
//             </button>
//           </div>

//           {/* Sidebar Overlay */}
//           {isSidebarOpen && (
//             <div 
//               className="fixed inset-0 bg-black/50 backdrop-blur-sm z-40"
//               onClick={() => setIsSidebarOpen(false)}
//             ></div>
//           )}

//           {/* Sidebar for mobile */}
//           <div 
//             ref={sidebarRef} 
//             className={`fixed top-0 right-0 h-full w-72 sm:w-80 md:w-96 bg-white z-50 transform transition-transform duration-300 ease-in-out overflow-y-auto shadow-2xl ${isSidebarOpen ? 'translate-x-0' : 'translate-x-full'}`}
//           >
//             <div className="p-6 sm:p-8 md:p-10">
//               {/* Sidebar Header */}
//               <div className="flex justify-between items-center mb-8">
//                 <h2 className="text-xl sm:text-2xl font-bold text-gray-800">Menu</h2>
//                 <button 
//                   onClick={() => setIsSidebarOpen(false)}
//                   className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
//                 >
//                   <i className="fa fa-times text-gray-600 text-xl"></i>
//                 </button>
//               </div>

//               <ul className="space-y-1">
//                 {/* About Us Mobile Dropdown */}
//                 <li className="border-b border-gray-100">
//                   <button 
//                     className="w-full flex justify-between items-center py-4 text-base sm:text-lg font-medium text-gray-800 hover:text-gray-600 transition-colors"
//                     onClick={() => setIsMobileAboutOpen(!isMobileAboutOpen)}
//                   >
//                     <span>About Us</span>
//                     <i className={`fa ${isMobileAboutOpen ? 'fa-chevron-up' : 'fa-chevron-down'} text-sm transition-transform duration-300`}></i>
//                   </button>

//                   <div className={`overflow-hidden transition-all duration-300 ${isMobileAboutOpen ? 'max-h-96 mb-4' : 'max-h-0'}`}>
//                     <ul className="pl-4 space-y-2">
//                       {aboutItems.map((item, index) => (
//                         <li key={index}>
//                           <Link 
//                             to={item.link} 
//                             className="block py-2 text-sm sm:text-base text-gray-600 hover:text-gray-800 hover:pl-2 transition-all duration-200"
//                             onClick={() => setIsSidebarOpen(false)}
//                           >
//                             <i className={`fa ${item.icon} mr-2 text-xs`}></i>
//                             {item.name}
//                           </Link>
//                         </li>
//                       ))}
//                     </ul>
//                   </div>
//                 </li>

//                 <li className="border-b border-gray-100">
//                   <Link 
//                     to='/masajids' 
//                     className="block py-4 text-base sm:text-lg font-medium text-gray-800 hover:text-gray-600 transition-colors"
//                     onClick={() => setIsSidebarOpen(false)}
//                   >
//                     Our Masajids
//                   </Link>
//                 </li>

//                 <li className="border-b border-gray-100">
//                   <Link 
//                     to='/' 
//                     className="block py-4 text-base sm:text-lg font-medium text-gray-800 hover:text-gray-600 transition-colors"
//                     onClick={() => setIsSidebarOpen(false)}
//                   >
//                     Donators
//                   </Link>
//                 </li>

//                 <li className="border-b border-gray-100">
//                   <Link 
//                     to='/ourcause' 
//                     className="block py-4 text-base sm:text-lg font-medium text-gray-800 hover:text-gray-600 transition-colors"
//                     onClick={() => setIsSidebarOpen(false)}
//                   >
//                     Causes
//                   </Link>
//                 </li>

//                 {/* Resources Mobile Dropdown */}
//                 <li className="border-b border-gray-100">
//                   <button 
//                     className="w-full flex justify-between items-center py-4 text-base sm:text-lg font-medium text-gray-800 hover:text-gray-600 transition-colors"
//                     onClick={() => setIsMobileResourcesOpen(!isMobileResourcesOpen)}
//                   >
//                     <span>Resources</span>
//                     <i className={`fa ${isMobileResourcesOpen ? 'fa-chevron-up' : 'fa-chevron-down'} text-sm transition-transform duration-300`}></i>
//                   </button>

//                   <div className={`overflow-hidden transition-all duration-300 ${isMobileResourcesOpen ? 'max-h-96 mb-4' : 'max-h-0'}`}>
//                     <ul className="pl-4 space-y-2">
//                       {resources.map((resource, index) => (
//                         <li key={index}>
//                           <Link 
//                             to={resource.link} 
//                             className="block py-2 text-sm sm:text-base text-gray-600 hover:text-gray-800 hover:pl-2 transition-all duration-200"
//                             onClick={() => setIsSidebarOpen(false)}
//                           >
//                             <i className={`fa ${resource.icon} mr-2 text-xs`}></i>
//                             {resource.name}
//                           </Link>
//                         </li>
//                       ))}
//                     </ul>
//                   </div>
//                 </li>

//                 <li className="pt-4">
//                   <Link 
//                     to='/donate' 
//                     className="block w-full text-center py-3 sm:py-4 text-base sm:text-lg font-medium text-white bg-gray-800 hover:bg-gray-700 rounded-lg transition-colors shadow-md"
//                     onClick={() => setIsSidebarOpen(false)}
//                   >
//                     Make Donation
//                   </Link>
//                 </li>
//               </ul>
//             </div>
//           </div>
//         </nav>
//       </header>

//       {/* Desktop Header */}
//       <div className={`hidden xl:block fixed top-0 left-0 right-0 z-30 transition-all duration-300 ${scrolled ? 'bg-white/95 backdrop-blur-md shadow-md py-3' : 'bg-transparent py-4 2xl:py-5'}`}>
//         <div className=" ">
//           <div className="flex justify-between xl:px-20 items-center">
            
//             {/* Logo on the left */}
//             <div className="flex-shrink-0">
//               <Link to='/'>
//                 <img 
//                   className={`transition-all duration-300 hover:scale-105 ${scrolled ? 'w-20 2xl:w-24' : 'w-24 2xl:w-28 3xl:w-32'}`} 
//                   src='images/favicon.ico' 
//                   alt="Logo" 
//                 />
//               </Link>
//             </div>

//             {/* Navigation */}
//             <div className="flex items-center gap-1 2xl:gap-2">

//               {/* About Us Dropdown */}
//               <div
//                 ref={aboutDropdownRef}
//                 className="relative"
//                 onMouseEnter={() => setIsAboutDropdownOpen(true)}
//                 onMouseLeave={() => setIsAboutDropdownOpen(false)}
//               >
//                 <button className={`px-4 2xl:px-5 py-2 2xl:py-2.5 font-medium text-sm 2xl:text-base transition-all duration-200 rounded-lg relative group ${scrolled ? 'text-gray-800 hover:text-gray-600' : 'text-white hover:text-gray-200'}`}>
//                   About Us 
//                   <i className={`fa fa-angle-down ml-1 text-xs transition-transform duration-200 ${isAboutDropdownOpen ? 'rotate-180' : ''}`}></i>
//                   <span className={`absolute bottom-0 left-0 w-0 h-0.5 bg-current transition-all duration-300 group-hover:w-full`}></span>
//                 </button>

//                 {isAboutDropdownOpen && (
//                   <div className="absolute top-full left-0 w-48 bg-white shadow-xl rounded-lg z-50 border border-gray-100 mt-1 overflow-hidden">
//                     <ul className="py-2">
//                       {aboutItems.map((item, index) => (
//                         <li key={index}>
//                           <Link
//                             to={item.link}
//                             className="flex items-center gap-3 px-4 py-3 hover:bg-gray-800 transition-colors duration-150 group"
//                           >
//                             {/* <i className={`fa ${item.icon} text-gray-400 group-hover:text-gray-600 transition-colors text-sm`}></i> */}
//                             <span className="text-sm font-medium text-gray-700 group-hover:text-white">
//                               {item.name}
//                             </span>
//                           </Link>
//                         </li>
//                       ))}
//                     </ul>
//                   </div>
//                 )}
//               </div>

//               {/* Our Masajids */}
//               <Link to='/masajids'>
//                 <button className={`px-4 2xl:px-5 py-2 2xl:py-2.5 font-medium text-sm 2xl:text-base transition-all duration-200 rounded-lg relative group ${scrolled ? 'text-gray-800 hover:text-gray-600' : 'text-white hover:text-gray-200'}`}>
//                   Our Masajids
//                   <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-current transition-all duration-300 group-hover:w-full"></span>
//                 </button>
//               </Link>

//               {/* Our Causes */}
//               <Link to='/ourcause'>
//                 <button className={`px-4 2xl:px-5 py-2 2xl:py-2.5 font-medium text-sm 2xl:text-base transition-all duration-200 rounded-lg relative group ${scrolled ? 'text-gray-800 hover:text-gray-600' : 'text-white hover:text-gray-200'}`}>
//                   Our Causes
//                   <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-current transition-all duration-300 group-hover:w-full"></span>
//                 </button>
//               </Link>

//               {/* Resources Dropdown */}
//               <div
//                 ref={resourcesDropdownRef}
//                 className="relative"
//                 onMouseEnter={() => setIsResourcesDropdownOpen(true)}
//                 onMouseLeave={() => setIsResourcesDropdownOpen(false)}
//               >
//                 <button className={`px-4 2xl:px-5 py-2 2xl:py-2.5 font-medium text-sm 2xl:text-base transition-all duration-200 rounded-lg relative group ${scrolled ? 'text-gray-800 hover:text-gray-600' : 'text-white hover:text-gray-200'}`}>
//                   Resources 
//                   <i className={`fa fa-angle-down ml-1 text-xs transition-transform duration-200 ${isResourcesDropdownOpen ? 'rotate-180' : ''}`}></i>
//                   <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-current transition-all duration-300 group-hover:w-full"></span>
//                 </button>

//                 {isResourcesDropdownOpen && (
//                   <div className="absolute top-full left-0 w-48 bg-white shadow-xl rounded-lg z-50 border border-gray-100 mt-1 overflow-hidden">
//                     <ul className="py-2">
//                       {resources.map((resource, index) => (
//                         <li key={index}>
//                           <Link
//                             to={resource.link}
//                             className="flex items-center gap-3 px-4 py-3 hover:bg-gray-900 transition-colors duration-150 group"
//                           >
//                             {/* <i className={`fa ${resource.icon} text-gray-400 group-hover:text-gray-600 transition-colors text-sm`}></i> */}
//                             <span className="text-sm font-medium text-gray-700 group-hover:text-white">
//                               {resource.name}
//                             </span>
//                           </Link>
//                         </li>
//                       ))}
//                     </ul>
//                   </div>
//                 )}
//               </div>

//               {/* Make Donation Button */}
//               <Link to='/donate'>
//                 <button className="px-5 2xl:px-4 py-2 2xl:py-2.5 ml-2 2xl:ml-4 text-white bg-gray-800 hover:bg-gray-700 font-medium text-sm 2xl:text-base transition-all duration-200 rounded-3xl shadow-md hover:shadow-lg hover:scale-105">
//                   Make Donation
//                 </button>
//               </Link>

//             </div>
//           </div>
//         </div>
//       </div>

//     </div>
//   );
// }

// export default Header;



// import React, { useEffect, useRef, useState } from 'react';
// import '@fortawesome/fontawesome-free/css/all.min.css';
// import { Link } from 'react-router-dom';

// function Header() {
//   // header functionality
//   const [isAboutDropdownOpen, setIsAboutDropdownOpen] = useState(false);
//   const [isResourcesDropdownOpen, setIsResourcesDropdownOpen] = useState(false);
//   const [isSidebarOpen, setIsSidebarOpen] = useState(false);
//   const [isMobileAboutOpen, setIsMobileAboutOpen] = useState(false);
//   const [isMobileResourcesOpen, setIsMobileResourcesOpen] = useState(false);
//   const toggleRef = useRef(null);
//   const sidebarRef = useRef(null);

//   const resources = [
//   { name: 'Library', link: '/library', icon: 'fa-book' },
//   { name: 'Events', link: '/eventslist', icon: 'fa-calendar' },
//   { name: 'Ask our Ulema', link: '/contactus', icon: 'fa-envelope' },
// ];


//  const aboutItems = [
//   { name: 'Golden Past', link: '/aboutus', icon: 'fa-history' },
//   { name: 'Office Bearers', link: '/officebearers', icon: 'fa-user-tie' },
//   { name: 'District Committee', link: '/commitee', icon: 'fa-users-cog' },
//   { name: 'Brochures', link: '/brochures', icon: 'fa-book-open' }

// ];


//   const toggleSidebar = () => {
//     setIsSidebarOpen(!isSidebarOpen);
//   };

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (
//         isSidebarOpen &&
//         sidebarRef.current &&
//         !sidebarRef.current.contains(event.target) &&
//         !toggleRef.current.contains(event.target)
//       ) {
//         setIsSidebarOpen(false);
//       }
//     };
//     document.addEventListener('mousedown', handleClickOutside);
//     return () => {
//       document.removeEventListener('mousedown', handleClickOutside);
//     };
//   }, [isSidebarOpen]);

//   return (
//     <div className=''>
//       {/* Logo */}
//       <div className='absolute z-30 top-5 md:top-3 left-3 md:left-12'>
//         <Link to='/'>
//           <img className='w-20 md:w-32' src='images/favicon.ico' alt="Logo" />
//         </Link>
//       </div>

//       {/* Mobile screen header */}
//       <header>
//         <nav className='flex items-center justify-between'>
//           <div className='absolute top-6 right-0 md:right-10'>
//             <button ref={toggleRef} onClick={toggleSidebar} className="p-4 xl:hidden relative z-30">
//               <i className="fa fa-bars text-white text-3xl md:text-4xl" aria-hidden="true"></i>
//             </button>
//           </div>

//           {/* Sidebar for mobile */}
//           <div ref={sidebarRef} className={`xl:hidden fixed top-20 right-0 w-56 md:w-64 rounded-tl-lg rounded-bl-lg py-0 px-0 bg-transparent z-50 transform transition-transform duration-300 overflow-y-auto ease-in-out ${isSidebarOpen ? 'translate-x-0' : 'translate-x-full'}`}>
//             <ul className="p-4 bg-black text-center font-alumni h-full text-white space-y-2">
//               {/* About Us Mobile Dropdown */}
//               <li>
//               <button 
//   className="w-full flex justify-center items-center gap-1 py-2 text-md md:text-lg font-mono"
//   onClick={() => setIsMobileAboutOpen(!isMobileAboutOpen)}
// >
//   <span>About Us</span>
//   <i className={`fa ${isMobileAboutOpen ? 'fa-chevron-up' : 'fa-chevron-down'}`}></i>
// </button>

//                 {isMobileAboutOpen && (
//                   <ul className="pl-4 mt-2 space-y-1 text-sm">
//                     {aboutItems.map((item, index) => (
//                       <li key={index}>
//                         <Link to={item.link} className="block py-1 hover:underline">{item.name}</Link>
//                       </li>
//                     ))}
//                   </ul>
//                 )}
//               </li>

//               <li><Link to='/masajids' className="block py-2 text-md md:text-lg font-mono">Our Masajids</Link></li>
//               <li><Link to='/' className="block py-2 text-md md:text-lg font-mono">Donators</Link></li>
//               {/* <li><Link to='/commitee' className="block py-2 text-md md:text-lg font-mono">District Committees</Link></li> */}
//               <li><Link to='/ourcause' className="block py-2 text-md md:text-lg font-mono">Causes</Link></li>

//               {/* Resources Mobile Dropdown */}
//               <li>
//               <button 
//   className="w-full flex justify-center items-center gap-1 py-2 text-md md:text-lg font-mono"
//   onClick={() => setIsMobileResourcesOpen(!isMobileResourcesOpen)}
// >
//   <span>Resources</span>
//   <i className={`fa ${isMobileResourcesOpen ? 'fa-chevron-up' : 'fa-chevron-down'}`}></i>
// </button>

//                 {isMobileResourcesOpen && (
//                   <ul className="pl-4 mt-2 space-y-1 text-sm">
//                     {resources.map((resource, index) => (
//                       <li key={index}>
//                         <Link to={resource.link} className="block py-1 hover:underline">{resource.name}</Link>
//                       </li>
//                     ))}
//                   </ul>
//                 )}
//               </li>

//               <li><Link to='/donate' className="block py-2 text-md md:text-lg font-mono">Donation</Link></li>
//             </ul>
//           </div>
//         </nav>
//       </header>

//       {/* Big screen header */}
//       <div className="hidden xl:block absolute top-10 2xl:top-10 left-1/2 transform -translate-x-1/2 z-30  p-2 w-3/4 md:w-[70%] xl:w-[70%] 2xl:w-[63%] 3xl:w-[70%]">
//         <div className="flex justify-center items-center xl:gap-4 2xl:gap-8 3xl:gap-8">

// {/* border border-gray-50 shadow-lg rounded-full */}


//           {/* About Us Dropdown */}
// <div
//   className="relative"
//   onMouseEnter={() => setIsAboutDropdownOpen(true)}
//   onMouseLeave={() => setIsAboutDropdownOpen(false)}
// >
//   <button className="px-5 py-2 text-[#ffffff] font-serif 2xl:text-md transition-all duration-200 rounded-md">
//     About Us <i className="fa fa-angle-down ml-1 text-xs"></i>
//   </button>

//   {isAboutDropdownOpen && (
//     <div className="absolute top-full left-1/2 -translate-x-1/2 w-64 bg-white shadow-2xl rounded-xl z-50 animate-fade-in border border-gray-100 mt-1">
//       {/* Triangle pointer */}
//       <div className="absolute -top-2 left-1/2 transform -translate-x-1/2 w-4 h-4 bg-white rotate-45 border-l border-t border-gray-100 shadow-sm z-10"></div>

//       <ul className="py-2 space-y-1 relative z-20">
//         {aboutItems.map((item, index) => (
//           <li key={index}>
//             <Link
//               to={item.link}
//               className="flex items-center gap-3 px-4 py-3 hover:bg-gray-50 transition duration-200 group"
//             >
//               {/* <div className="flex h-10 w-10 bg-gray-100 rounded-full items-center justify-center text-gray-800 group-hover:bg-gray-800 group-hover:text-white transition">
//                 <i className={`fa ${item.icon}`}></i>
//               </div> */}
//               <div className="text-left">
//                 <p className="text-sm font-semibold text-gray-800 group-hover:text-gray-800">
//                   {item.name}
//                 </p>
//                 <p className="text-xs text-gray-500 group-hover:text-gray-600">
//                   Learn more
//                 </p>
//               </div>
//             </Link>
//           </li>
//         ))}
//       </ul>
//     </div>
//   )}
// </div>


//           {/* Other buttons */}
//           <button className="text-[#ffffff] 2xl:text-md hover:underline p-2 rounded-lg font-serif">
//             <Link to='/masajids'>Our Masajids</Link>
//           </button>

         

//           {/* <button className="text-[#ffffff] 2xl:text-md hover:underline p-2 rounded-lg font-serif">
//             <Link to='/commitee'>District Committees</Link>
//           </button> */}

//           <button className="text-[#ffffff] 2xl:text-md hover:underline p-2 rounded-lg font-serif">
//             <Link to='/ourcause'>Our Causes</Link>
//           </button>

//           {/* Resources Dropdown */}
         
// <div
//   className="relative"
//   onMouseEnter={() => setIsResourcesDropdownOpen(true)}
//   onMouseLeave={() => setIsResourcesDropdownOpen(false)}
// >
//   <button className="px-5 py-2 text-[#ffffff] font-serif 2xl:text-md transition-all duration-200 rounded-md">
//     Resources <i className="fa fa-angle-down ml-1 text-xs"></i>
//   </button>

//   {isResourcesDropdownOpen && (
//     <div className="absolute top-full left-1/2 -translate-x-1/2 w-64 bg-white shadow-2xl rounded-xl z-50 animate-fade-in border border-gray-100 mt-1">
//       {/* Triangle pointer */}
//       <div className="absolute -top-2 left-1/2 transform -translate-x-1/2 w-4 h-4 bg-white rotate-45 border-l border-t border-gray-100 shadow-sm z-10"></div>

//       <ul className="py-2 space-y-1 relative z-20">
//         {resources.map((resource, index) => (
//           <li key={index}>
//             <Link
//               to={resource.link}
//               className="flex items-center gap-3 px-4 py-3 hover:bg-gray-50 transition duration-200 group"
//             >
//               {/* <div className="flex h-10 w-10 bg-gray-100 rounded-full items-center justify-center text-gray-800 group-hover:bg-gray-800 group-hover:text-white transition">
//                 <i className={`fa ${resource.icon}`}></i>
//               </div> */}
//               <div className="text-left">
//                 <p className="text-sm font-semibold text-gray-800 group-hover:text-gray-800">
//                   {resource.name}
//                 </p>
//                 <p className="text-xs text-gray-500 group-hover:text-gray-600">
//                   Explore now
//                 </p>
//               </div>
//             </Link>
//           </li>
//         ))}
//       </ul>
//     </div>
//   )}
// </div>



//           {/* Make Donation Button */}
//           <button className="text-white bg-gray-800 p-2 rounded-lg font-serif">
//             <Link to='/donate'>Make Donation</Link>
//           </button>

//         </div>
//       </div>

//     </div>
//   );
// }

// export default Header;




// // #225B4B]